import React from 'react';
import { trackFbEvent } from '../utils/fbPixel';
const trackOutbound = (target: string) => trackFbEvent('OutboundClick', {
  target
});
export function Footer() {
  return <footer className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 border-t" style={{
    background: 'linear-gradient(180deg, rgb(240,253,244) 0%, rgb(255,255,255) 40%)',
    borderTopColor: 'rgba(34,197,94,0.2)'
  }} data-id="element-148">
      <div className="mx-auto max-w-4xl text-center" data-id="element-149">

        {/* Logo */}
        <div className="mb-3 text-xl font-black tracking-[2.4px] text-green-700" data-id="element-150">
          🥑 BIBLIOTECA PROFESIONAL™
        </div>

        {/* Tagline */}
        <p className="mx-auto max-w-[576px] text-xs leading-[20px] text-gray-600 m-0 mb-3" data-id="element-151">
          El sistema N°1 para nutricionistas que quieren trabajar mejor, cobrar
          lo que merecen y crecer en Argentina.
        </p>

        <p className="text-xs italic text-gray-500 m-0 mb-6 px-4" data-id="element-152">
          "Porque ejercer la nutrición con criterio clínico no debería
          demandarte todas tus noches y fines de semana."
        </p>

        {/* Contact Info */}
        <div className="mb-6 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-xs text-gray-600" data-id="element-153">
          <a href="mailto:soporte@bibliotecaprofesional.com" onClick={() => trackOutbound('email')} className="no-underline text-gray-600 hover:text-green-700 transition-colors" data-id="element-154">
            📧 soporte@bibliotecaprofesional.com
          </a>
          <span className="hidden sm:block text-gray-200" data-id="element-155">|</span>
          <span className="text-gray-600" data-id="element-156">📲 @biblioteca.profesional</span>
          <span className="hidden sm:block text-gray-200" data-id="element-157">|</span>
          <a href="https://www.bibliotecaprofesional.com" target="_blank" rel="noopener noreferrer" onClick={() => trackOutbound('website')} className="no-underline text-gray-600 hover:text-green-700 transition-colors" data-id="element-158">
            🌐 www.bibliotecaprofesional.com
          </a>
        </div>

        {/* Divider */}
        <div className="mx-auto mb-6 h-px w-24 bg-green-700/30" data-id="element-159" />

        {/* Legal & Copyright */}
        <div className="space-y-1" data-id="element-160">
          <p className="text-[10px] text-gray-500 m-0" data-id="element-161">
            © {new Date().getFullYear()} Biblioteca Profesional™ — Todos los
            derechos reservados.
          </p>
          <p className="text-[10px] text-gray-400 m-0" data-id="element-162">
            Prohibida la reproducción total o parcial y la redistribución sin
            autorización expresa.
          </p>
        </div>

      </div>
    </footer>;
}